import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel } from "./../../../../models/plano-acao-model";
import { PlanoAcaoService } from "./../../../../services/plano-acao.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../services/auth.service";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { IEnumModel } from "../../../../models/enum.model";
import { PlanoAcaoRecomendacaoComponent } from "../../../plano-acao/plano-acao-form/plano-acao-recomendacao/plano-acao-recomendacao.component";
import { IResponsavelWithTipoSelectModel } from "../../../../models/responsaveis.model";


@Component({
  selector: 'app-plano-acao-form-acao-avaliada',
  templateUrl: './plano-acao-form-acao-avaliada.component.html',
  styleUrls: ['./plano-acao-form-acao-avaliada.component.scss']
})

export class PlanoAcaoFormAcaoAvaliadaComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaRecomendacaoPaginator", { static: true })
  tabelaRecomendacaoPaginator: MatPaginator;
  @ViewChild("tabelaRecomendacaoSort", { static: true })
  tabelaRecomendacaoSort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;

  public model = this.createModel();

  public dataSourceRecomendacao = new MatTableDataSource<IAcaoPlanoAcaoRecomendacaoModel>([]);

  public tituloModal = "";
  public visualizar = false;
  public alterar = false;
  public id: number = 0;
  public planoAcaoId: number = 0;
  public unidadeGestoraId: number = 0;
  public osaExecucaoId: number = 0;
  public avaliacao: number = 1;
  public statusAtualDesc: string = '';
  public statusAtualCodigo: number = 0;
  public responsaveis: IResponsavelWithTipoSelectModel[];



  private readonly statusAvaliada = [
    { codigo: 5, descricao: "Cancelada" },
    { codigo: 6, descricao: "A ser Realizada" }
  ];

  get statusList() {
    // ação adicionada após a avaliação não pode ser cancelada
    return this.model?.adicionadaAposAvaliacao
      ? this.statusAvaliada.filter(s => s.codigo === 6)
      : this.statusAvaliada;
  }
  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public planoAcaoService: PlanoAcaoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<PlanoAcaoFormAcaoAvaliadaComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.alterar = data?.alterar;
    this.tituloModal = data?.titulo;
    this.planoAcaoId = data?.planoAcaoId;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.osaExecucaoId = data?.osaExecucaoId;
    if (data?.element) {
      this.model = data?.element;
    }
  }

  ngOnInit(): void {
    this.obterResponsaveis(this.unidadeGestoraId);
    if (this.id)
      this.obter(this.id);
  }

  private createModel(): IAcaoPlanoAcaoModel {
    return {
      id: 0,
      planoAcaoId: this.planoAcaoId,
      planoAcao: {} as IPlanoAcaoModel,
      identificador: 0,
      titulo: '',
      descricao: '',
      responsavelId: '',
      responsavelNome: '',
      prazo: new Date,
      status: { codigo: 1, nome: 'Cadastrada', descricao: 'Cadastrada' } as IEnumModel,
      justificativaAvaliacao: '',
      nivelRelevancia: null,
      comentarioAuditor: '',
      descricaoImplementacao: '',
      dataRealizacao: null,
      descricaoImplementacaoAuditor: '',
      avaliacao: null,
      dataMonitoramento: null,
      responsavelIdMonitoramento: '',
      responsavelNomeMonitoramento: '',
      responsavelCargoMonitoramento: '',
      recomendacoes: [],
      evidencias: [],
      evidenciasAuditor: [],
      adicionadaAposAvaliacao: false
    };
  }

  public obterResponsaveis(id: any) {

    this.responsaveis = [];

    this.planoAcaoService.obterResponsaveis(id).then((res) => {
      if (res.sucesso) {
        this.responsaveis = res.dados;
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }


  public obter(id: number) {

    this.planoAcaoService
      .obterAcaoPorId(id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.model.prazo = new Date(this.model.prazo);
          this.statusAtualDesc = this.model.status.descricao;
          this.statusAtualCodigo = this.model.status.codigo;

          if (this.model.avaliacao)
            this.avaliacao = this.model.avaliacao.codigo;


          //-> se nao for vizualização, limpa o status se nao for 5 ou 6
          if (!this.visualizar && this.model.status.codigo != 5 && this.model.status.codigo != 6) {
            this.model.status = null;
          }

          this.dataSourceRecomendacao.data = this.model?.recomendacoes;
          this.dataSourceRecomendacao.paginator = this.tabelaRecomendacaoPaginator;
          this.dataSourceRecomendacao.sort = this.tabelaRecomendacaoSort;
          this.dataSourceRecomendacao.sortingDataAccessor = this.sortingDataAccessor;

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "titulo":
        return item.recomendacao.titulo;
      default:
        return item[property];
    }
  };


  public modalRecomendacao(element?: IAcaoPlanoAcaoRecomendacaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-recomendacao";
    dialogConfig.width = "50vw";
    dialogConfig.height = "45vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Recomendação",
      element
    };

    const modal = this.matDialog.open(PlanoAcaoRecomendacaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public salvar() {

    if ((!this.model.status) || (this.model.status.codigo != 5 && this.model.status.codigo != 6)) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Status da Ação não informado!",
      });
      return;
    }

    if (!this.model.responsavelId) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Resonsável da Ação não informado!",
      });
      return;
    }

    if (!this.model.comentarioAuditor) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Comentário da Avaliação não informado!",
      });
      return;
    }

    //-> Editar a ação avaliada
    this.planoAcaoService
      .editarAcaoAvaliada(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public fechar() {
    this.dialogRef.close();
  }

  public cancelar() {
    Swal.fire({
      title: "Cancelar",
      text: "Todas os dados não salvos serão perdidos. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.dialogRef.close();
      }
    });
  }

}

